/**
 * Identifier.
 */
export type Id = string | undefined

/**
 * Creates an ID.
 * @param value
 */
export function Id(value?: string | null): Id {
  return value || undefined
}

/**
 * No ID.
 */
Id.none = undefined as Id

/**
 * Returns `true` if `ID` has an actual value.
 */
Id.some = (id: Id): id is string => !!id

/**
 * Asserts that ID is specified.
 */
Id.assert = (id: Id): string => {
  if (!id) {
    throw new Error('ID is required, but was empty.')
  }
  return id
}
